import React, { FC } from 'react'

import { css, cx } from '@linaria/core'

import { VoidHandler, WithChildren, WithDataName } from 'common/types'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { modalOpenAttribute } from 'components/layout/ModalLayout/modalOpen'
import { WrapperElement } from 'components/layout/ModalLayout/WrapperElement'
import { useIsScreenHeightLayout } from 'hooks/useIsScreenHeightLayout'
import { useModalOpened } from 'hooks/useModalOpened'
import { useOperationSystem } from 'hooks/useOperationSystem'
import { useRedesignLayout } from 'hooks/useRedesign'

export const ModalWrapper: FC<
  {
    isAuthPage?: boolean
    isMambaPartner?: boolean
    onClick?: VoidHandler
  } & WithDataName &
    WithChildren
> = (props) => {
  const modalOpened = useModalOpened()
  const operationSystem = useOperationSystem()
  const redesignLayout = useRedesignLayout()
  const isScreenHeightLayout = useIsScreenHeightLayout()

  const newProps = {
    ...props,
    [modalOpenAttribute]: modalOpened,
  }

  /* id необходимо для знакомства для фикса https://redmine.mamba.ru/issues/99606 */
  return (
    <WrapperElement
      id="app-wrapper"
      {...newProps}
      $operationSystem={operationSystem}
      className={cx(
        redesignLayout && redesignCss,
        redesignLayout && isScreenHeightLayout && screenHeightCss
      )}
    />
  )
}

const redesignCss = css`
  align-items: center;
`
const screenHeightCss = css`
  @media screen and (min-width: ${breakpoints.mobile + 1}px) {
    height: 100vh;
  }
`
